import apiClient from "../../common/apiClient";
import Form from "react-bootstrap/Form";
import Config from "../../common/Config";
import FieldState from "../../common/FieldState";
import OrderFormStep from "../../common/OrderFormStep";
import FormTitle from "../../components/formTitle/FormTitle";
import "../../components/measurement/measurement.scss";
import MuiRadio from "../../components/radio/MuiRadio";
import "../../steps/forms.scss";
import RangeSlider from "../../components/range/RangeSlider";
import InputTextField from "../../components/textField/InputTextField";
import ShapeCreationRadio from "../../components/shapeCreationRadio/ShapeCreationRadio";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";

import ttBodyPart from "../../images/ttBodyPart.png";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import ClearOrder from "../../components/modal/ClearOrder";
import { AreNotesLessThanMaxLength, MaxInputLength, OnFileChange } from '../../common/common';

export default class ShapeCreation extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCADFileId = 101;
    this.fromCastId = 98;
    this.fromScanId = 100;
    this.UOM_InchId = 14;

    this.nextCartQueueIndex = 0;
    this.displayedCartIndex = 0;

    this.state = {
      shapeCreations: [],
      trimlines: [],
      modifications: [],
      UOMs: [],
      isLoading: false,
      isSubmit: false,
      patientId: null,
      formState: {
        shapeCreation: new FieldState(true),
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        scanFileName: new FieldState(false),
        trimline: new FieldState(true),
        modification: new FieldState(true),
        shapeCreationNotes: new FieldState(false),
        amount: new FieldState(false, 0),
        flexion: new FieldState(false, 3),
        adduction: new FieldState(false, 3),
        UOM: new FieldState(false),
        PMLWidth: new FieldState(false),
        MPTToFloor: new FieldState(false),
        AboveMPT15cm: new FieldState(false),
        AboveMPT10cm: new FieldState(false),
        AboveMPT5cm: new FieldState(false),
        AboveMPT0cm: new FieldState(false),
        BelowMPT5cm: new FieldState(false),
        BelowMPT10cm: new FieldState(false),
        BelowMPT15cm: new FieldState(false),
        BelowMPT20cm: new FieldState(false),
        ML: new FieldState(false),
        AP: new FieldState(false),
        LimbLength: new FieldState(false),
      },
    };

    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleFlexionChange = this.handleFlexionChange.bind(this);
    this.handleAdductionChange = this.handleAdductionChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.addFile = this.addFile.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.shapeCreations, this.state.formState.shapeCreation.value, "shapeCreation");
    addToCart(this.state.trimlines, this.state.formState.trimline.value, "trimline");
    addToCart(this.state.modifications, this.state.formState.modification.value, "modification");

    let config = {};
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();
    
    return apiClient.get("price/" + this.props.formTypeId +"/",
      config
    ).then(response => {
      let data = response.data
      cart = cart.map(c => {
        if (c.name == "From Cast") {
          c.name = "Create Electronic Shape";
        }
        return {
          name: c.name,
          partNumber: c.partNumber,
          quantity: c.quantity,
          price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
          sourceId: c.sourceId
        }
      });

      cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
        return {
          name: d.name,
          partNumber: d.partNumber,
          quantity: d.quantity,
          price: d.price,
          sourceId: d.sourceId
        }
      }));
      
      if(this.shouldDisplayCart(index)) {
        this.props.setTempCart(cart);
      }
    }).catch(error =>{
      console.log(error)
    });
  }

  handleAmountChange(e, value) {
    let formState = this.state.formState;
    formState.amount.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleFlexionChange(e, value) {
    let formState = this.state.formState;
    formState.flexion.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleAdductionChange(e, value) {
    let formState = this.state.formState;
    formState.adduction.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  componentDidMount() {
    this.loadData();
    this.loadMeasurementData();
  }

  async loadData() {
    try {
      this.setState({
        shapeCreations: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "shapeCreation" },
            }
          )
        ).data,
        trimlines: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "trimline" },
            }
          )
        ).data,
        modifications: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "modification" },
            }
          )
        ).data,
      });

      let formState = this.state.formState;

      let headers = {
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await apiClient.get("cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      let patientInfo1Config = {
        headers: {},
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await apiClient.get("patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data.patientId;

      this.setState({
        patientId: patientInfo1Data
      })

      let config = {
        headers: headers,
        params: {
          fieldNames: [
            "shapeCreation",
            "scanFileName",
            "trimline",
            "modification",
            "measurementNotes",
            "flexion",
            "modificationPercentage",
            "modificationPly",
            "adduction",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      // debugger;

      formState.shapeCreation.value = data.find(
        (fi) => fi.fieldName === "shapeCreation"
      ).fieldOptionId;

      formState.scanFileName.value = data.find(
        (fi) => fi.fieldName === "scanFileName"
      ).stringData;

      formState.trimline.value = data.find(
        (fi) => fi.fieldName === "trimline"
      ).fieldOptionId;

      formState.modification.value = data.find(
        (fi) => fi.fieldName === "modification"
      ).fieldOptionId;


      formState.shapeCreationNotes.value = data.find(
        (fi) => fi.fieldName === "measurementNotes"
      ).stringData;

      formState.flexion.value =
        data.find((fi) => fi.fieldName === "flexion").numericData ?? 3;
      formState.adduction.value =
        data.find((fi) => fi.fieldName === "adduction").numericData ?? 3;

      if (this.isPercentageSelected()) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "modificationPercentage"
        ).numericData;
      } else if (this.isPlySelected()) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "modificationPly"
        ).numericData;
      }

      formState.cadFileName.isRequired = this.isFromCADFileSelected();
      formState.scanFileName.isRequired = this.isFromScanSelected();
      this.setState({ formState: formState });

      this.loadCart();
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  saveData() {

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "shapeCreation",
      fieldOptionId: this.state.formState.shapeCreation.value,
    });

    fieldInputData.push({
      fieldName: "modification",
      fieldOptionId: this.state.formState.modification.value,
    });

    fieldInputData.push({
      fieldName: "trimline",
      fieldOptionId: this.state.formState.trimline.value,
    });

    fieldInputData.push({
      fieldName: "scanFileName",
      stringData: this.isFromScanSelected()
        ? this.state.formState.scanFileName.value
        : null,
    });

    fieldInputData.push({
      fieldName: "measurementNotes",
      stringData: this.state.formState.shapeCreationNotes.value,
    });

    fieldInputData.push({
      fieldName: "modificationPercentage",
      numericData: this.isPercentageSelected()
        ? this.state.formState.amount.value
        : null,
    });

    fieldInputData.push({
      fieldName: "modificationPly",
      numericData: this.isPlySelected()
        ? this.state.formState.amount.value
        : null,
    });

    fieldInputData.push({
      fieldName: "flexion",
      numericData: this.state.formState.flexion.value,
    });

    fieldInputData.push({
      fieldName: "adduction",
      numericData: this.state.formState.adduction.value,
    });

    let promises = [];
    const fields = [
      "UOM",
      "PMLWidth",
      "MPTToFloor",
      "AboveMPT15cm",
      "AboveMPT10cm",
      "AboveMPT5cm",
      "AboveMPT0cm",
      "BelowMPT5cm",
      "BelowMPT10cm",
      "BelowMPT15cm",
      "BelowMPT20cm",
      "ML",
      "AP",
      "LimbLength",
    ];

    if (this.state.formState.cadFile.value !== "" && this.isFromCADFileSelected()) {
      const formData = new FormData();

      formData.append("cadFile", this.state.formState.cadFile.value);
      promises.push(
        apiClient.post("cadFiles/" + this.props.formTypeId,
          formData
        )
      );
    }
    
    if (this.state.formState.cadFileName.value != "" && !this.isFromCADFileSelected()){
      const formData = new FormData();

      formData.append("cadFile",null,);
      promises.push(
        apiClient.put("cadFiles/" + this.props.formTypeId,formData)
      );
    }

    if (this.state.formState.shapeCreation.value !== 99) {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = false;
      }
    } else {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = true;
      }
    }

    if (this.validateData().isValid) {
      if (this.state.formState.shapeCreation.value === 99) {
        promises.push(this.saveMeasurementData());
      }
      promises.push(
        apiClient.post("fieldInputs/" + this.props.formTypeId,fieldInputData)
      );
      Promise.all(promises)
        .then(
          ([res, res2]) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            }
          })
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  async loadMeasurementData() {
    try {
      this.setState({
        UOMs: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "UOM" } }
          )
        ).data,
      });

      let config = {
        params: {
          fieldNames: [
            "UOM",
            "PMLWidth",
            "MPTToFloor",
            "AboveMPT15cm",
            "AboveMPT10cm",
            "AboveMPT5cm",
            "AboveMPT0cm",
            "BelowMPT5cm",
            "BelowMPT10cm",
            "BelowMPT15cm",
            "BelowMPT20cm",
            "ML",
            "AP",
            "LimbLength",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.UOM.value = data.find(
        (fi) => fi.fieldName === "UOM"
      ).fieldOptionId;
      formState.PMLWidth.value =
        data.find((fi) => fi.fieldName === "PMLWidth").numericData ?? "";
      formState.MPTToFloor.value =
        data.find((fi) => fi.fieldName === "MPTToFloor").numericData ?? "";
      formState.LimbLength.value =
        data.find((fi) => fi.fieldName === "LimbLength").numericData ?? "";
      formState.AboveMPT15cm.value =
        data.find((fi) => fi.fieldName === "AboveMPT15cm").numericData ?? "";
      formState.AboveMPT10cm.value =
        data.find((fi) => fi.fieldName === "AboveMPT10cm").numericData ?? "";
      formState.AboveMPT5cm.value =
        data.find((fi) => fi.fieldName === "AboveMPT5cm").numericData ?? "";
      formState.AboveMPT0cm.value =
        data.find((fi) => fi.fieldName === "AboveMPT0cm").numericData ?? "";
      formState.BelowMPT5cm.value =
        data.find((fi) => fi.fieldName === "BelowMPT5cm").numericData ?? "";
      formState.BelowMPT10cm.value =
        data.find((fi) => fi.fieldName === "BelowMPT10cm").numericData ?? "";
      formState.BelowMPT15cm.value =
        data.find((fi) => fi.fieldName === "BelowMPT15cm").numericData ?? "";
      formState.BelowMPT20cm.value =
        data.find((fi) => fi.fieldName === "BelowMPT20cm").numericData ?? "";
      formState.ML.value =
        data.find((fi) => fi.fieldName === "ML").numericData ?? "";
      formState.AP.value =
        data.find((fi) => fi.fieldName === "AP").numericData ?? "";

      this.setState({ formState: formState });
    } catch (error) {
      console.log(error);
      // this.props.handleError(new LoadFailureResult());
    }

    // this.setState({ isLoaded: true });
  }

  saveMeasurementData() {

    let data = [];

    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });

    data.push({
      fieldName: "PMLWidth",
      numericData: this.state.formState.PMLWidth.value,
    });

    data.push({
      fieldName: "MPTToFloor",
      numericData: this.state.formState.MPTToFloor.value,
    });

    data.push({
      fieldName: "LimbLength",
      numericData: this.state.formState.LimbLength.value,
    });

    data.push({
      fieldName: "AboveMPT15cm",
      numericData: this.state.formState.AboveMPT15cm.value,
    });

    data.push({
      fieldName: "AboveMPT10cm",
      numericData: this.state.formState.AboveMPT10cm.value,
    });

    data.push({
      fieldName: "AboveMPT5cm",
      numericData: this.state.formState.AboveMPT5cm.value,
    });

    data.push({
      fieldName: "AboveMPT0cm",
      numericData: this.state.formState.AboveMPT0cm.value,
    });

    data.push({
      fieldName: "BelowMPT5cm",
      numericData: this.state.formState.BelowMPT5cm.value,
    });

    data.push({
      fieldName: "BelowMPT10cm",
      numericData: this.state.formState.BelowMPT10cm.value,
    });

    data.push({
      fieldName: "BelowMPT15cm",
      numericData: this.state.formState.BelowMPT15cm.value,
    });

    data.push({
      fieldName: "BelowMPT20cm",
      numericData: this.state.formState.BelowMPT20cm.value,
    });

    data.push({
      fieldName: "ML",
      numericData: this.state.formState.ML.value,
    });

    data.push({
      fieldName: "AP",
      numericData: this.state.formState.AP.value,
    });

    return apiClient.post("fieldInputs/" + this.props.formTypeId,
      data
    );
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(5);
  }
  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  removeFile() {
    this.state.formState.cadFile.isRequired = false;
    this.state.formState.cadFileName.isRequired = false;
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  addFile() {
    if (this.state.formState.cadFileName.value !== "") {
      this.state.formState.cadFileName.isRequired = false;
    } else {
      this.state.formState.cadFileName.isRequired = true;
    }
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper ttCheck">
          <FormTitle
            title="Socket Design Specifications"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="measurementBorder">
              <ShapeCreationRadio
                options={this.state.shapeCreations}
                defaultValue={this.state.formState.shapeCreation.value}
                error={this.handleError("shapeCreation") && this.state.isSubmit}
                onChange={(e) => {
                  this.onRadioChange(e, "shapeCreation");
                  this.props.setActiveInnerStep(0)
                }}
                scanFileNameChange={(e) => {
                  this.onInputChange(e, "scanFileName");
                }}
                scanFileName={this.state.formState.scanFileName.value}
                removeFile={this.removeFile}
                addExistingFile={this.addFile}
                fileChange={(e) => OnFileChange(e, this)}
                fileName={this.state.formState.cadFileName.value}
                measurement={
                  <div className="measurementWrapper">
                    <MuiRadio
                      required={true}
                      options={this.state.UOMs}
                      defaultValue={this.state.formState.UOM.value}
                      error={this.handleError("UOM") && this.state.isSubmit}
                      label="Unit of Measurement"
                      onChange={(e) => {
                        this.onRadioChange(e, "UOM");
                      }}
                    />
                    <div className="unitPic">
                      <div className="measurement">
                        <div className="level">
                          <div className="unitTitle">
                            <span>Level</span>
                            <span>Measurement</span>
                          </div>

                          <div className="unit">
                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(15)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.AboveMPT15cm.value}
                                error={
                                  this.handleError("AboveMPT15cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "AboveMPT15cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(10)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.AboveMPT10cm.value}
                                error={
                                  this.handleError("AboveMPT10cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "AboveMPT10cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(5)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.AboveMPT5cm.value}
                                error={
                                  this.handleError("AboveMPT5cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "AboveMPT5cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(0)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.AboveMPT0cm.value}
                                error={
                                  this.handleError("AboveMPT0cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "AboveMPT0cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(5)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.BelowMPT5cm.value}
                                error={
                                  this.handleError("BelowMPT5cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "BelowMPT5cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(10)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.BelowMPT10cm.value}
                                error={
                                  this.handleError("BelowMPT10cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "BelowMPT10cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(15)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.BelowMPT15cm.value}
                                error={
                                  this.handleError("BelowMPT15cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "BelowMPT15cm");
                                }}
                              />
                            </div>

                            <div className="unitMeasurement">
                              <p>{this.getIntervalFromCM(20)}</p>
                              <InputTextField
                                placeholder="Enter Value"
                                variant="outlined"
                                value={this.state.formState.BelowMPT20cm.value}
                                error={
                                  this.handleError("BelowMPT20cm") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "BelowMPT20cm");
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="imgData">
                        <img
                          src={ttBodyPart}
                          alt="bodypart"
                          width="295px"
                          height="392"
                        />
                        <div className="inputs">
                          <div className="pml">
                            {this.imageMeasurementEntry("PMLWidth")}
                          </div>
                          <div className="ml">
                            {this.imageMeasurementEntry("ML")}
                          </div>

                          <div className="limb">
                            {this.imageMeasurementEntry("LimbLength")}
                          </div>

                          <div className="ap">
                            {this.imageMeasurementEntry("AP")}
                          </div>

                          <div className="mpt">
                            {this.imageMeasurementEntry("MPTToFloor")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }                
              />
       
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.trimlines}
                defaultValue={this.state.formState.trimline.value}
                label="Trimline"
                error={this.handleError("trimline") && this.state.isSubmit}
                required={this.state.formState["trimline"].isRequired}
                checked
                onChange={(e) => {
                  this.props.setActiveInnerStep(1);
                  this.onRadioChange(e, "trimline");
                }}
              />
            </div>

            <div className="fieldBorder fieldMargin">
              <MuiRadio
                options={this.state.modifications}
                defaultValue={this.state.formState.modification.value}
                error={this.handleError("modification") && this.state.isSubmit}
                label="Modifications"
                required={this.state.formState["modification"].isRequired}
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "modification");
                }}
              />

              <div className="fieldWrapper">
                {this.showAmount()}
              </div>
            </div>

            <div className="fieldBorder ">
              <h4 className="headLable">Angles</h4>
              <div className="fieldWrapper">
                <div className="rangeSlider">
                  <RangeSlider
                    label={this.showFlexion()}
                    min={-10}
                    max={10}
                    step={1}
                    minValue={"Extension"}
                    maxValue={"Flexion"}
                    unit="°"
                    initialValue={this.state.formState.flexion.value}
                    marks={""}
                    onChange={(e) => {
                      this.handleFlexionChange(e);
                      this.props.setActiveInnerStep(3);
                    }}
                  />

                  <RangeSlider
                    label={this.showAdduction()}
                    min={-10}
                    max={10}
                    step={1}
                    unit="°"
                    minValue={"Abduction"}
                    maxValue={"Adduction"}
                    initialValue={this.state.formState.adduction.value}
                    marks={""}
                    onChange={(e) => {
                      this.handleAdductionChange(e);
                      this.props.setActiveInnerStep(3);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable">Measurement Notes</h4>
              <InputTextField
                label="Measurement Notes"
                variant="outlined"
                placeholder={`Type Something here, please keep notes under ${MaxInputLength} characters...`}
                type="text"
                width="800px"
                multiline
                rows={6}
                required={this.state.formState.shapeCreationNotes.isRequired}
                error={this.handleError("shapeCreationNotes") && this.state.isSubmit}
                value={this.state.formState.shapeCreationNotes.value}
                onChange={(e) => {
                  this.onInputChange(e, "shapeCreationNotes");
                  this.props.setActiveInnerStep(4);
                }}
              />
            </div>
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                const checkNotesLength = AreNotesLessThanMaxLength([{ note: this.state.formState.shapeCreationNotes?.value, name: "Measurement Notes" }]);
                if (checkNotesLength.length > 0) {
                  CreateNotification(`'${checkNotesLength[0]}' field has exceeded character limit of ${MaxInputLength}`, "error");
                } else {
                  this.setState({ isLoading: true });
                  this.saveData();
                }
              }}
            />
          </div>
          <SaveAsDraft
            open={this.props.open}
            handleClose={this.props.handleClose}
            showSubmit={this.props.showSubmit}
            setShowSubmit={this.props.setShowSubmit}
          />
          <ClearOrder
            openClear={this.props.openClear}
            handleCloseClear={this.props.handleCloseClear}
            showClear={this.props.showClear}
            setShowClear={this.props.setShowClear}
            formId = {this.props.formTypeId}
            handleClearBack={this.props.handleClearBack}
          />
        </div>
      </>
    );
  }

  showFileUpload() {
    if (this.isFromCADFileSelected()) {
      return (
        <Form.Group controlId="cadFile">
          <Form.Label>
            CAD File: {this.state.formState.cadFileName.value}
          </Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => OnFileChange(e, this)}
            ref={(input) => {
              if (input === null) return;
              this.applyRequiredClass(input);
            }}
          />
        </Form.Group>
      );
    }
  }

  showScanFileName() {
    if (this.isFromScanSelected()) {
      return (
        <Form.Group controlId="scanFileName">
          <Form.Label>Scan File Name</Form.Label>
          {this.makeFormControl()}
        </Form.Group>
      );
    }
  }

  isFromCastSelected() {
    return this.state.formState.shapeCreation.value === this.fromCastId;
  }

  isFromScanSelected() {
    return this.state.formState.shapeCreation.value === this.fromScanId;
  }

  isFromCADFileSelected() {
    return this.state.formState.shapeCreation.value === this.fromCADFileId;
  }

  showAmount() {
    if (this.isPercentageSelected() || this.isPlySelected()) {
      return (
        <Form.Group controlId="amount">
          <div className="range">
            <RangeSlider
              min={-10}
              max={10}
              step={1}
              minValue={"-10"}
              maxValue={"+10"}
              unit={this.getAmountText()}
              label={`Amount`}
              initialValue={this.state.formState.amount.value}
              onChange={(e) => {
                this.handleAmountChange(e)
                this.props.setActiveInnerStep(2);
              }}
            />
          </div>
        </Form.Group>
      );
    }
  }

  getAmountText() {
    let amountText;
    let amount = this.state.formState.amount.value;

    if (this.isPercentageSelected()) {
      amountText = "%";
    } else {
      amountText = " Ply";
    }

    if (amount >= 0) {
      amountText += " Increase";
    } else {
      amountText += " Reduction";
    }

    return amountText;
  }

  isPercentageSelected() {
    return this.state.formState.modification.value === 152;
  }

  isPlySelected() {
    return this.state.formState.modification.value === 153;
  }

  showFlexion() {
    let flexion = this.state.formState.flexion.value;
    let directionPrefix;
    if (flexion >= 0) {
      directionPrefix = "Flexion: ";
    } else {
      directionPrefix = "Extension: ";
    }

    return directionPrefix + Math.abs(flexion) + "°";
  }

  showAdduction() {
    let adduction = this.state.formState.adduction.value;
    let directionPrefix;
    if (adduction >= 0) {
      directionPrefix = "Adduction: ";
    } else {
      directionPrefix = "Abduction: ";
    }

    return directionPrefix + Math.abs(adduction) + "°";
  }

  getAbsValue(value) {
    return Math.abs(value);
  }

  getIntervalFromCM(cm) {
    if (this.state.formState.UOM.value === this.UOM_InchId) {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }

  imageMeasurementEntry(id, left, top) {
    return (
      <>
        {/* <TextField
        id={id}
        type="number"
        required
        style={{
          position: "absolute",
          left: left,
          top: top,
          width: 50,
        }}
        value={this.state.formState[id].value}
        className={this.getClassName(id)}
        onChange={this.onInputChange}
      /> */}
        <InputTextField
          placeholder="1"
          width="60px"
          type="number"
          id={id}
          error={this.handleError(id) && this.state.isSubmit}
          value={this.state.formState[id].value}
          onChange={(e) => this.onInputChange(e, id)}
        />
      </>
    );
  }
}